import TriMoji from "./TriMoji";

const CelebrateCompliment = TriMoji({ top: "🤲", mid: "✨", bottom: "🎉" });

export default CelebrateCompliment;
